import { useEffect, useRef } from 'react';
import { createRoot } from 'react-dom/client';

import './upgrade.scss';

document.addEventListener('DOMContentLoaded', () => {
    const upgradePageEl = document.getElementById('apbUpgradePage');

    createRoot(upgradePageEl).render(<UpgradePageContent />);
});

const UpgradePageContent = () => {
    const countdownRef = useRef(null);

    useEffect(() => {
        downCount(countdownRef?.current, {
            date: `12/03/2023 12:00:00`
            // offset: +6
        });
    }, []);

    return <>
        <section className='intro'>
            <div className='container'>
                <div className='introHeader flex'>
                    <span>Experience the thrill of Cyber Monday with an epic 40% off!</span> <span style={{ color: '#ff5757' }}>Ending On</span>
                    {/* <img width='60px' src='https://tastewp.com/intro/emoji.svg' /> */}
                </div>

                <div className='countdownWrap'>
                    <div className='countdown' ref={countdownRef}>
                        <div>
                            <span className='days'>00</span>
                            <span className='days_ref'>days</span>
                        </div>
                        <span>:<br />&nbsp;</span>
                        <div>
                            <span className='hours'>00</span>
                            <span className='hours_ref'>hours</span>
                        </div>
                        <span>:<br />&nbsp;</span>
                        <div>
                            <span className='minutes'>00</span>
                            <span className='minutes_ref'>minutes</span>
                        </div>
                        <span>:<br />&nbsp;</span>
                        <div>
                            <span className='seconds'>00</span>
                            <span className='seconds_ref'>seconds</span>
                        </div>
                    </div>
                </div>

                <div className='promoCode'>
                    Coupon: [FSBFCM2023]
                </div>

                {/* <div className='outbox'>
                    <h3>Dont want it to expire?</h3>

                    <div className='grid'>
                        <div className='outboxCard'>
                            <label className='flex'>
                                <img width='19px' height='19px' src='https://tastewp.com/intro/share-icon.svg?a' />
                                Share TasteWP
                            </label>

                            <p>
                                Share the link below with your followers & friends.
                                <br />
                                For every 3 people who sign up, you get one non-expiring site (up to 3)!
                            </p>

                            <button id='copy' className='button white' data-copy='https://tastewp.com/r/CharlesCormier'
                                style={{ backgroundImage: `url(https://tastewp.com/intro/copy.png)` }}>
                                TasteWP.com/r/CharlesCormier
                            </button>

                            <small>(Click on button to copy link)</small>
                        </div>

                        <div className='outboxCard'>
                            <label className='flex'>
                                <img width='19px' height='19px' src='https://tastewp.com/intro/crown.svg?f' />
                                Go Premium
                            </label>

                            <div className='list flex'>
                                <div className='flex listItem'>
                                    <img width='34px' height='34px' src='https://tastewp.com/intro/pro-web.svg?a' />
                                    No expiry
                                </div>
                                <div className='flex listItem'>
                                    <img width='34px' height='34px' src='https://tastewp.com/intro/pro-space.svg?a' />
                                    More space
                                </div>
                                <div className='flex listItem'>
                                    <img width='34px' height='34px' src='https://tastewp.com/intro/pro-support.svg?a' />
                                    Top support
                                </div>
                            </div>

                            <button id='copy' className='button yellow' data-copy='https://tastewp.com/r/CharlesCormier'
                                style={{ backgroundImage: `url(https://tastewp.com/intro/crown-bg.svg?a)` }}>
                                TasteWP.com/r/CharlesCormier
                            </button>

                            <small>From 2.98 USD/month only - cancel anytime</small>

                            <div className='corner'>
                                <a href='https://tastewp.com/premium-show' target='_blank' rel="noreferrer">
                                    Learn more
                                </a>
                            </div>
                        </div>
                    </div>
                </div> */}
            </div>
        </section>


        <div className='fsUpgradePrice'>
            <iframe src="https://wp.freemius.com/pricing/?plugin_id=14262&amp;plugin_public_key=pk_87f141adce326dfb96ba4e12d8a36&amp;plugin_version=1.12.1&amp;s_ctx_type=install&amp;s_ctx_id=13628791&amp;s_ctx_ts=1700391158&amp;s_ctx_secure=eb9a75f4e08238b0503308d46009a65d&amp;post_type=apb&amp;page=advanced-post-block-pricing&amp;next=http%3A%2F%2Flocalhost%2Fdevelopment%2Fwp-admin%2Fedit.php%3Fpost_type%3Dapb%26fs_action%3Dadvanced-post-block_sync_license%26page%3Dadvanced-post-block-account&amp;billing_cycle=annual&amp;is_network_admin=false&amp;currency=usd#http%3A%2F%2Flocalhost%2Fdevelopment%2Fwp-admin%2Fedit.php%3Fpost_type%3Dapb%26page%3Dadvanced-post-block-pricing" width="100%" height="800px" scrolling="no" frameBorder="0" style={{ background: 'transparent', width: '1px', minWidth: '100%', height: '2763px' }}></iframe>
        </div>
    </>
}

const downCount = (container, options, callback) => {
    const settings = Object.assign({ date: null, offset: null }, options);

    const getText = (sl) => container.querySelector(sl).textContent;
    const setText = (sl, val) => {
        container.querySelector(sl).textContent = val;
    }

    if (!settings.date) {
        throw new Error('Date is not defined.');
    }

    if (!Date.parse(settings.date)) {
        throw new Error('Incorrect date format, it should look like this, 12/24/2012 12:00:00.');
    }

    const currentDate = () => {
        // get the client's current date
        const date = new Date();

        // turn the date to UTC
        const utc = date.getTime() + (date.getTimezoneOffset() * 60000);

        return new Date(utc + (3600000 * settings.offset)); // return a new Date object
    }

    function countdown() {
        // difference of dates
        const difference = new Date(settings.date) - currentDate();

        // if the difference is negative, then it's past the target date
        if (difference < 0) {
            // stop the timer
            clearInterval(interval);

            if (callback && typeof callback === 'function') {
                callback();
            }

            return;
        }

        // basic math variables
        const _second = 1000;
        const _minute = _second * 60;
        const _hour = _minute * 60;
        const _day = _hour * 24;

        // calculate dates
        var days = Math.floor(difference / _day);
        var hours = Math.floor((difference % _day) / _hour);
        var minutes = Math.floor((difference % _hour) / _minute);
        var seconds = Math.floor((difference % _minute) / _second);

        // fix dates so that they will show two digits
        days = (String(days).length >= 2) ? days : '0' + days;
        hours = (String(hours).length >= 2) ? hours : '0' + hours;
        minutes = (String(minutes).length >= 2) ? minutes : '0' + minutes;
        seconds = (String(seconds).length >= 2) ? seconds : '0' + seconds;

        // based on the date change the reference wording
        var refDays = days === '01' ? 'day' : 'days';
        var refHours = hours === '01' ? 'hour' : 'hours';
        var refMinutes = minutes === '01' ? 'minute' : 'minutes';
        var refSeconds = seconds === '01' ? 'second' : 'seconds';

        // set the values to the DOM
        setText('.days', days);
        setText('.hours', hours);
        setText('.minutes', minutes);
        setText('.seconds', seconds);

        getText('.days_ref') === 'days' && setText('.days_ref', refDays);
        getText('.hours_ref') === 'hours' && setText('.hours_ref', refHours);
        getText('.minutes_ref') === 'minutes' && setText('.minutes_ref', refMinutes);
        getText('.seconds_ref') === 'seconds' && setText('.seconds_ref', refSeconds);
    }

    // start
    var interval = setInterval(countdown, 1000);

    // Return the interval for later use or stopping the countdown if needed
    return interval;
}